var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEtam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 181,
    viewBox: "0 0 184 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.928 19L183.128 6.8C183.128 6.8 100.128 -20.4 60.7281 34C60.7281 34 43.5281 61.2 76.4281 74.8C76.4281 74.8 25.6281 76.3 2.02812 131.4C2.02812 131.4 -13.7719 173.6 42.8281 180.8C42.8281 180.8 77.1281 183.6 121.528 164.3L130.828 145.7C130.828 145.7 86.4281 164.3 57.9281 157.9C57.9281 157.9 27.1281 149.3 47.8281 115.7C47.8281 115.7 67.1281 79.2 126.528 81.4L132.928 71.4C132.928 71.4 77.8281 72.8 87.1281 40.6C87.2281 40.5 100.128 2.6 175.928 19Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtam);
export default __webpack_public_path__ + "static/media/etam.85d29478fe9e3513de173b34e53fb94e.svg";
export { ForwardRef as ReactComponent };